var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Small from '../../typography/Small';
import { Anchor, CobrowseButton, Divider, FooterWrapper, InfoWrapper, LinkItem, LinkItemButton, LinkList } from './subcomponents';
import CobrowseIcon from '../../icons/Cobrowse';
const Footer = (_a) => {
    var { body, linkList, className, id, showCobrowse, showCookieSetting, cobrowseButtonAriaLabel = 'Start Cobrowse', cobrowseDataReason = 'co-browse', cookieSettingButtonLabel = 'Cookie Settings', cobrowseDataType = '' } = _a, props = __rest(_a, ["body", "linkList", "className", "id", "showCobrowse", "showCookieSetting", "cobrowseButtonAriaLabel", "cobrowseDataReason", "cookieSettingButtonLabel", "cobrowseDataType"]);
    const sessionStart = () => {
        var _a, _b, _c, _d;
        const windowWithSurfly = window;
        return (_d = (_c = (_b = (_a = windowWithSurfly.Surfly) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.startLeader) === null || _d === void 0 ? void 0 : _d.call(_c);
    };
    return (React.createElement(FooterWrapper, Object.assign({ className: className, id: id }, props),
        React.createElement(InfoWrapper, null, body),
        React.createElement(Divider, null),
        React.createElement(LinkList, null,
            linkList.map((link) => {
                const { url, id: childId, dataReason, dataType, text } = link;
                return (React.createElement(LinkItem, { key: childId },
                    React.createElement(Small, null,
                        React.createElement(Anchor, { id: childId, href: url, "data-analytics": "clicktrackingevent", "data-object": "link", "data-type": dataType, "data-reason": dataReason, target: "_blank" }, text))));
            }),
            showCookieSetting && (React.createElement(LinkItem, { key: "cookie-setting-button" },
                React.createElement(LinkItemButton, { id: "ot-sdk-btn", className: "ot-sdk-show-settings", type: "button", "data-object": "button", buttonType: "text", "data-analytics": "clicktrackingevent" },
                    React.createElement(Small, { weight: "bold" }, cookieSettingButtonLabel)))),
            showCobrowse && (React.createElement(LinkItem, { key: "cobrowse-button" },
                React.createElement(CobrowseButton, { id: "start-cobrowse-jS", "aria-label": cobrowseButtonAriaLabel, type: "button", onClick: sessionStart, "data-type": cobrowseDataType, "data-reason": cobrowseDataReason, "data-object": "button", "data-analytics": "clicktrackingevent" },
                    React.createElement(CobrowseIcon, { height: 20 })))))));
};
export default Footer;
